import Api from 'services/Api';
import _ from 'lodash';

// Mutation Types
const mutationTypes = {
    UPDATE: 'UPDATE',
    RESULT: 'RESULT',
    RESET: 'RESET'
};

// Initial State
const state = {
    preOrPost: null,
    gender: null,
    ageOfDeceased: 0,
    dateOfBirth: null,
    dateOfDeath: null,
    dateOfTrialOrCessation: null,
    discountResult: 0,
    label: 'Pre or Post-assessment Discount',
    tableData: null,
    explanation: null,
};

// Getters
const getters = {
    value: state => key => state[key],
};

/**
 * Gate the Api calls
 *
 * @param state
 * @returns {boolean}
 */
function calcMultiplier(state) {
    return (state.preOrPost !== null
            && state.gender !== null
            && state.ageOfDeceased >= 10
            && state.ageOfDeceased <= 90
            && state.dateOfDeath !== null
            && state.dateOfDeath !== ''
            && state.dateOfTrialOrCessation !== null
            && state.dateOfTrialOrCessation !== '');
}

// Actions
const actions = {
    update({ commit }, { key, value }) {
        commit(mutationTypes.UPDATE, { key, value });
    },
    calcMultiplier: _.debounce(({ dispatch, state }) => {
        if (calcMultiplier(state)) {
            return Api.miniCalculators.multipliers.tableEandF(state)
                .then(data => dispatch('result', data));
        }
    }, 500),
    result({ commit }, data) {
        commit(mutationTypes.RESULT, data);
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.preOrPost = null;
        state.gender = null;
        state.ageOfDeceased = 0;
        state.dateOfBirth = null;
        state.dateOfDeath = null;
        state.dateOfTrialOrCessation = null;
        state.discountResult = 0;
        state.label = 'Pre or Post-assessment Discount';
        state.tableData = null;
        state.explanation = null;
    },
    [mutationTypes.RESULT](state, data) {
        state.discountResult = data.result;
        state.label = data.label;
        state.tableData = data.tableData;
        state.explanation = data.explanation;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/tableDiscounts.js